import React from "react";
import { Link } from "react-router-dom";
import { KenteStripe } from "./Primitives";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-edge bg-ink" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <span className="font-serif text-3xl font-semibold text-bone">Our African Narratives</span>
            <p className="mt-4 max-w-sm leading-relaxed text-muted">
              An un-erased history. Our African Narratives uncovers the majesty of African civilizations, the truth of the
              trans-Atlantic slave trade, and the enduring contributions of the global diaspora.
            </p>
          </div>
          <div className="md:col-span-3">
            <h4 className="mb-4 font-mono text-[11px] uppercase tracking-[0.2em] text-gold">Explore</h4>
            <ul className="space-y-2 text-sm text-muted">
              <li><Link to="/kingdoms" className="hover:text-bone">Kingdoms & Empires</Link></li>
              <li><Link to="/timeline" className="hover:text-bone">Historical Timeline</Link></li>
              <li><Link to="/dispersion" className="hover:text-bone">Dispersion Map</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <h4 className="mb-4 font-mono text-[11px] uppercase tracking-[0.2em] text-gold">Learn</h4>
            <ul className="space-y-2 text-sm text-muted">
              <li><Link to="/lessons" className="hover:text-bone">Lessons for Educators</Link></li>
              <li><Link to="/quizzes" className="hover:text-bone">Quizzes</Link></li>
              <li><Link to="/tutor" className="hover:text-bone">Ask the AI Tutor</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-edge pt-6 text-xs text-muted">
          Built for parents and educators teaching un-erased Black History from its roots.
        </div>
      </div>
      <KenteStripe />
    </footer>
  );
}
